export default __webpack_public_path__ + "static/media/section2.e63c6918.jpg";